import {combineReducers} from '@reduxjs/toolkit';
import account from './get-account.slice'

const authReducers = combineReducers({
  account
});

export default authReducers;